import forOwn from 'lodash/forOwn';
import BaseInput from '@/mixins/BaseInput';

export default {
  mixins: [BaseInput],
  props: {
    value: Object,
    errors: {
      type: Object,
      default: () => ({}),
    },
    size: String,
  },
  data() {
    return {
      internalErrors: this.getErrorMessages(this.errors),
    };
  },
  watch: {
    errors(errors) {
      this.internalErrors = this.getErrorMessages(errors);
    },
  },
  computed: {
    isInvalid() {
      return this.internalErrors.length > 0;
    },
    isValid() {
      return !this.isInvalid;
    },
    inputCss() {
      return {
        'uk-form-danger': this.isInvalid,
        [`uk-form-${this.size}`]: !!this.size,
      };
    },
  },
  methods: {
    clearErrors() {
      this.internalErrors = [];
    },
    getErrorMessages(errors) {
      const messages = [];
      forOwn(errors, (fieldMessages, key) => {
        const fieldName = this.$t(`fields.${key}`);
        fieldMessages.forEach((message) => {
          if (key === 'base') {
            messages.push(message);
          } else {
            messages.push(`${fieldName}: ${message}`);
          }
        });
      });
      return messages;
    },
  },
};



// WEBPACK FOOTER //
// ./mixins/ComplexInput.js